import styled from "styled-components";

export const Container = styled.div``;

export const ContainerModal = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-bottom: 54px;

  text-align: start;

  > h4 {
    /* font-family: AvertaPE; */
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.15px;
    color: #1b2852;
    margin-bottom: 24px;
    padding: 0 16px;
    width: 90%;
  }

  > p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0.15px;
    color: #69769b;
    margin-bottom: 36px;
    padding: 0 16px;
  }

  button {
    margin-top: 32px;
  }

  .containerButton {
    text-align: center;
    margin-top: 50px;
  }
`;
